<template lang="pug">
    el-upload.uploader(
        :multiple='false'
        :show-file-list="false"
        drag
        action="none"
        accept='image/*'
        :on-preview='onFilePreview'
        :http-request='handleFileUpload'
        :on-success='onUploadSuccess'
        :style="uploaderStyle"
        :class='{placeholder: !imageUrl}'
    )
      .overlay
        i.upload-icon.el-icon-upload2
        .desc
          template(v-if="imageUrl") Click to replace image
          template(v-else) Drop file here or click to upload
        el-button(v-if="imageUrl" @click.stop='onClear') Clear

      el-progress.progress-bar(v-if='uploadPercentage' :percentage="uploadPercentage")

</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    initialUrl: {
      type: String
    },
    bucketKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      uploadPercentage: null,
      fullUrl: null,
      cleared: false
    };
  },
  computed: {
    imageUrl() {
      if (this.cleared) {
        return null;
      }

      return this.fullUrl || this.initialUrl || null;
    },
    uploaderStyle() {
      return {
        backgroundImage: this.imageUrl
          ? `url(${this.imageUrl})`
          : `url(${require("@/assets/images/placeholder-image.png")})`
      };
    }
  },
  methods: {
    handleFileUpload({ file }) {
      return this.$store.dispatch("upload/uploadFile", {
        file,
        bucketKey: this.bucketKey,
        options: { onProgress: this.onUploadProgress }
      });
    },
    onUploadProgress(percentage) {
      this.uploadPercentage = percentage;
    },
    onFilePreview({ url }) {
      window.open(url);
    },
    onUploadSuccess({ fullUrl, path }) {
      this.fullUrl = fullUrl;
      this.cleared = false;
      this.$emit("input", path);
      this.uploadPercentage = 0;
    },
    onClear() {
      this.cleared = true;
      this.fullUrl = null;
      this.$emit("input", null);
      this.uploadPercentage = 0;
    }
  }
};
</script>

<style scoped lang="scss">
.progress-bar {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
}

.uploader {
  background-position: center center;
  background-size: cover;
  width: 50%;
  border-radius: 2px;
  background-color: white;
  border: 1px solid #bfcbd9;

  :global(.el-upload) {
    display: block;
  }

  :global(.el-upload-dragger) {
    width: 100%;
    border: 0;
    background: transparent;
    position: relative;
    border-radius: 2px;
  }

  &.placeholder {
    background-size: contain;
  }
}

.upload-icon {
  display: block;
  font-size: 40px;
  color: white;
}

.overlay {
  opacity: 0;
  transition: opacity 250ms ease-in-out;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:hover {
    opacity: 1;
  }
}

.desc {
  color: white;
  margin-top: 10px;
}
</style>
